<template>
  <w-sliding-popup ref="slidingPopup" type="setting" :title="popupTitle" @close="closePopup" width="500px">
    <el-form slot="content" :ref="formName" :model="tierInfo" :rules="rules" label-position="top">
      <div class="mr-b20">
        <el-form-item label="티어명" prop="tierName">
          <el-input v-model="tierInfo.tierName" placeholder="입력해 주십시오." />
        </el-form-item>
      </div>
      <el-form-item label="트랜잭션 Apdex" prop="txApdexTimeMillis">
        <el-input-number v-model="tierInfo.txApdexTimeMillis" /> ms
      </el-form-item>
      <el-form-item label="엔드유저 Apdex" prop="enduserApdexTimeMillis">
        <el-input-number v-model="tierInfo.enduserApdexTimeMillis" /> ms
      </el-form-item>
      <el-form-item label="기본 티어" prop="defaultApplyFlag">
        <el-switch v-model="tierInfo.defaultApplyFlag" active-value="Y" inactive-value="N" :disabled="disabledApplyFlag" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="large" type="solid" :disabled="!disabledSaveBtn" @click="saveTier">저장</el-button>
      <el-button size="large" @click="closePopup">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { clone, isEqual } from 'lodash';
import ApmSettingAPI from '@/api/settings/apm/apm-setting';
import msgUtil from '@/utils/message';

export default {
  name: 'WTierSettingPopup',
  props: {
    popupType: {
      type: String,
    },
  },
  data() {
    return {
      formName: 'tierSettingForm',
      tierInfo: {},
      originalTierInfo: {},
      rules: {
        tierName: { required: true, trigger: 'blur', message: '값을 입력해주세요' },
      },
    };
  },
  computed: {
    popupTitle() {
      return this.popupType === 'ADD' ? '티어 추가' : '티어 변경';
    },
    disabledSaveBtn() {
      return !isEqual(this.originalTierInfo, this.tierInfo);
    },
    disabledApplyFlag() {
      return this.originalTierInfo.defaultApplyFlag === 'Y';
    },
  },
  methods: {
    closePopup() {
      this.$refs[this.formName].resetFields();
      this.$refs.slidingPopup.visible = false;
    },
    open(tierInfo) {
      this.$refs.slidingPopup.visible = true;
      this.tierInfo = clone(tierInfo);
      this.originalTierInfo = clone(tierInfo);
    },
    /**
     * 1. 기본 티어를 바꾸려고 할 경우 기존의 기본티어는 해제 된다는 메시지창을 띄운 후 저장.
     * 2. 티어 저장
     * 3. 티어명이 없을 경우 입력사항 확인 메시지창
     * @return {[type]} [description]
     * @author jda
     */
    saveTier() {
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          const tierInfo = this.tierInfo;
          // 기존 기본 티어가 아니었지만, 기본 티어로 바꾸려고 할 경우 메시지창을 띄운다.
          if (this.originalTierInfo.defaultApplyFlag !== tierInfo.defaultApplyFlag && tierInfo.defaultApplyFlag === 'Y') {
            this.$confirm('저장하시겠습니까?<br/>(기존의 기본 티어는 해제됩니다.)', msgUtil.title.CONFIRM, {
              ...msgUtil.defaultConfirmButton,
              dangerouslyUseHTMLString: true,
            }).then(() => {
              this.requestData();
            }).catch(() => {});
          } else {
            this.requestData();
          }
        } else {
          this.$message(msgUtil.getCustomMsgData('입력사항을 확인해주십시오.'));
        }
      });
    },
    /**
     * 티어 저장한다.
     * @return {[type]} [description]
     * @author jda
     */
    requestData() {
      const url = this.popupType === 'ADD' ? 'insertTier' : 'updateTier';
      ApmSettingAPI[url](this.tierInfo).then((response) => {
        if (response.data.success) {
          this.$emit('reloadData');
          this.closePopup();
        }
        this.$message(msgUtil.getResultMsgData(msgUtil.action[this.popupType], '티어', response.data.success));
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/apm/ConfigSettings/components/popup/TierSettingPopup.vue